import { luscinia } from "./luscinia";

export function initDragAndDropTarget() {
    const selectorString = "table[data-luscinia-allow-dragdrop=true]";

    const bootgrids = document.querySelectorAll(selectorString) as NodeListOf<HTMLTableElement>;
    const root = document.querySelector(":root") as HTMLElement;
    const initialDragArea = document.getElementById("pcont");
    const styleSheet = getStyleSheetByHref("style.min.css");

    bootgrids.forEach(function (bootgrid) {
        const cssSelector = `.table-container:has(${selectorString})::after`;

        let tableContainer: HTMLElement | null = null;
        if (bootgrid != null) {
            tableContainer = bootgrid.closest(".table-container") as HTMLElement;
        }

        let enterTarget: EventTarget | null = null;
        let cssAdded = false;

        if (tableContainer != null && initialDragArea) {
            ["dragover", "drop"].forEach(function (type) {
                document.addEventListener(type, function (event) {
                    event.preventDefault();
                });
            });

            // --- DRAG ENTER ---
            initialDragArea.addEventListener("dragenter", function (event: DragEvent) {
                if (event.dataTransfer && hasFiles(event.dataTransfer)) {
                    addDraggableAreaCss(event);
                }
            });

            // --- DRAG LEAVE / END ---
            ["dragend", "dragleave"].forEach((type) => {
                initialDragArea.addEventListener(type, ((event: DragEvent) => {
                    if (event.dataTransfer && hasFiles(event.dataTransfer)) {
                        removeDraggableAreaCss(event);
                    }
                }) as EventListener);
            });

            // --- DROP ON INITIAL AREA (outside table) ---
            initialDragArea.addEventListener("drop", function (event: DragEvent) {
                if (event.dataTransfer && hasFiles(event.dataTransfer)) {
                    forceRemoveDraggableAreaCss(event);
                }
            });

            // --- DROP ON TABLE CONTAINER ---
            tableContainer.addEventListener("drop", function (event: DragEvent) {
                if (!event.dataTransfer || !hasFiles(event.dataTransfer)) return;

                const files = event.dataTransfer.files;
                forceRemoveDraggableAreaCss(event);

                luscinia.openNewRecordModal($(bootgrid), luscinia.config).then(function () {
                    const inputElDropTarget = document.querySelector("input[data-luscinia-isdraganddroptarget=true]") as HTMLInputElement;

                    if (!inputElDropTarget.hasAttribute("multiple") && files.length > 1) {
                        luscinia.showNotification("Not Allowed", "cannot upload multiple in this field", "danger");
                        return;
                    }

                    inputElDropTarget.files = files;
                    inputElDropTarget.dispatchEvent(new Event("change"));
                });
            });

            // --- VISUAL FEEDBACK ---
            tableContainer.addEventListener("dragenter", function (event: DragEvent) {
                if (event.dataTransfer && hasFiles(event.dataTransfer)) {
                    root.style.setProperty("--dragColor", "#849dffc0");
                }
            });

            tableContainer.addEventListener("dragleave", function (event: DragEvent) {
                if (event.dataTransfer && hasFiles(event.dataTransfer)) {
                    root.style.setProperty("--dragColor", "#d9dff794");
                }
            });
        }

        // --- HELPERS ---
        function hasFiles(dataTransfer: DataTransfer): boolean {
            return (
                dataTransfer.types &&
                (dataTransfer.types.includes("Files") ||
                    // Firefox compatibility
                    dataTransfer.types.includes("application/x-moz-file"))
            );
        }

        function addDraggableAreaCss(event: Event) {
            enterTarget = event.target;

            if (cssAdded) return;
            styleSheet?.insertRule(constructCssRule(), 0);
            cssAdded = true;
        }

        function constructCssRule() {
            return `${cssSelector} {
                content: '+';
                z-index: 500;
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 50px;
                font-weight: 500;
                text-align: center;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background-color: var(--dragColor);
                border: dashed 5px #3a5eff;
            }`;
        }

        function removeDraggableAreaCss(event: Event) {
            if (event.target !== enterTarget) return;
            styleSheet?.deleteRule(0);
            cssAdded = false;
        }

        function forceRemoveDraggableAreaCss(event: Event) {
            styleSheet?.deleteRule(0);
            cssAdded = false;
        }
    });
}

function getStyleSheetByHref(href: string) {
    for (let i = 0; i < document.styleSheets.length; i++) {
        const styleSheet = document.styleSheets[i];
        if (styleSheet.href && styleSheet.href.includes(href)) {
            return styleSheet as CSSStyleSheet;
        }
    }
    return null;
}
